import { createSlice } from '@reduxjs/toolkit';

import { actions } from './sender-state.actions';
import { ISenderStateInitial } from './sender-state.types';

const initialState: ISenderStateInitial = {
  stateId: '',
  sendingStateId: '',
  prefix: '',
  isSending: false,
  isLoading: false,
  isShowEmailErrors: false,
  progress: {
    totalSending: 0,
    totalSent: 0,
    totalDelivered: 0,
    totalBounced: 0,
    totalComplaints: 0,
    status: 'none',
    emailSendingErrors: [],
  },
};

const senderStateSlice = createSlice({
  name: 'senderStateSlice',
  initialState,
  reducers: actions,
});

export const senderStateReducer = senderStateSlice.reducer;
export const emailSenderStateActions = senderStateSlice.actions;
export const {
  updateProgress,
  setSendingState,
  resetSendingState,
  resetSendingProgress,
  setSendingErrors,
  setIsSendingEmail,
  resetIsSendingEmail,
  resetSendingErrors,
  setIsShowEmailErrors,
  resetSendingIsLoading,
} = senderStateSlice.actions;
